<template>
  <div id="views-page1">
    <!-- 头部标题 -->
    <HeaderTitle class="header-page" :title="title" :navIndex="5"></HeaderTitle>
    <!-- 内容 -->
    <div class="content">
      <!-- 左 -->
      <div class="left">
        <div class="title" style="padding: 10px 0 0 40px">溯源链条</div>
        <!-- 溯源记录 -->
        <div class="content-left-syjl">
          <!-- 线 -->
          <img
            style="height: 100%; width: 5%; margin-left: 5px"
            src="../../assets/suyuan/xian.png"
            alt=""
          />
          <!-- 记录 -->
          <div class="content-left-syjl-process">
            <div
              class="content-left-syjl-process-box"
              v-for="(item, index) in syprocess"
              :key="index"
              @mouseover="changeBackgroundColor(item.id)"
            >
              <img
                class="content-left-syjl-process-box-img1"
                :src="syprocessIndex == item.id ? item.drop2 : item.drop"
                alt=""
              />
              <div
                class="content-left-syjl-process-box-sj"
                :style="{
                  backgroundImage:
                    syprocessIndex == item.id
                      ? 'url(' + item.background2 + ')'
                      : 'url(' + item.background + ')',
                }"
              >
                <img
                  style="width: 85px; height: 100%; margin-right: 20px"
                  :src="syprocessIndex == item.id ? item.icon2 : item.icon"
                  alt=""
                />
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 中间 -->
      <div class="center">
        <div class="title" style="padding: 12px 0 0 40px">溯源信息</div>
        <!-- 操作信息 -->
        <div class="content-center-detail">
          <!-- 阶段时长 -->
          <div class="content-center-detail-left">
            <div class="content-center-detail-left-top">
              <div style="padding: 2px 0">
                <span
                  style="
                    font-size: 22px;
                    color: #43e793;
                    padding-right: 20px;
                    font-weight: 600;
                    letter-spacing: 2px;
                  "
                  >180天</span
                >
                <span>2023-12-01~2024-05-01</span>
              </div>
              <div style="font-size: 20px; font-weight: 600">阶段时长</div>
            </div>
            <div class="content-center-detail-left-bottom">
              <span style="font-size: 20px; font-weight: 600">现场照片</span>
              <img
                class="content-center-detail-left-bottom-imgg"
                :src="syList[syprocessIndex].icon"
                alt=""
              />
            </div>
          </div>
          <!-- 操作信息 -->
          <div class="content-center-detail-right">
            <!-- 标题 -->
            <div class="content-center-detail-right-title">
              <div class="content-center-detail-right-title2">操作信息</div>
            </div>
            <div class="content-center-detail-left-bottom-czxx">
              <span>鸡蛋名称：{{ syList[syprocessIndex].packName }}</span>
              <span>阶段名称：{{ syList[syprocessIndex].tile }}</span>
              <!-- <span>操作工：{{ syList[syprocessIndex].shebei }}</span> -->
              <span>阶段内容：{{ syList[syprocessIndex].title }}</span>
              <span>阶段时间：{{ syList[syprocessIndex].timestamp }}</span>
            </div>
          </div>
        </div>
        <!-- 生产视频 -->
        <div
          style="
            width: 100%;
            height: 548px;
            box-sizing: border-box;
            box-shadow: 0 0 5px 0 #6fc3df;
            padding: 10px;
          "
        >
          <video
            style="height: 100%; display: block; object-fit: cover; width: 100%"
            src="../../assets/suyuan/jidan2.mp4"
            controls
          ></video>
        </div>
      </div>
      <!-- 右 -->
      <div class="right">
        <div class="title" style="padding: 10px 0 0 40px;">溯源码</div>
        <div class="content-right-top">
          <div class="content-right-top-sym">
            <canvas
              id="qrcodeCanvas"
              style="width: 76%; height: 76%; margin: 12% auto; display: block"
            ></canvas>
          </div>
          <div
            style="
              width: 55%;
              height: 100%;
              letter-spacing: 2px;
              font-size: 17px;
            "
          >
            二维码溯源，是通过二维码(Qr-code)记录产品原材料、生产、检验、包装运输、销售及代理，以及用户及售后等信息，做到所有产品信息能从产品全生命周期内的信息可追溯，可查询真伪，可以追本潮源，进行系统管控的一种技术和方法。
          </div>
        </div>
        <!-- 赋码批次信息//溯源查询次数 -->
        <div style="width: 96%; margin: 0 auto;">
          <div class="jsqk-title">
            <div class="title" style="padding-left: 20px; padding-top: 0px;">
              赋码批次信息
            </div>
          </div>
          <div class="right-three-list-title">
              <div style="width: 33%; text-align: center">批次号</div>
              <div style="width: 33%; text-align: center">商家</div>
              <div style="width: 33%; text-align: center">日期</div>
            </div>
          <div style="width: 100%; height: 210px; margin-bottom: 20px; overflow: hidden;">
            <vue-seamless-scroll
              :class-option="classOptio"
              :data="listData"
              class="warp"
            >
              <div
                style="cursor: pointer"
                class="left-echarts-box-list-box"
                v-for="(item, index) in listData"
                :key="index"
              >
                <span style="width: 33%; text-align: center">
                  {{item.batch}}
                </span>
                <span style="width: 33%; text-align: center">{{
                  item.name
                }}</span>
                <span style="width: 33%; text-align: center"
                  >{{ item.time }}</span
                >
              </div>
            </vue-seamless-scroll>
          </div>
          <div class="jsqk-title">
            <div class="title" style="padding-left: 20px; padding-top: 0px">
              溯源查询次数
            </div>
          </div>
          <div style="width: 100%; height: 260px;">
            <numEcharts style="width: 100%; height: 260px;"></numEcharts>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderTitle from "../../components/HeaderTitle.vue";
import QRCode from "qrcode";
import numEcharts from '../../components/suyuan/numEcharts.vue';
// import axios from "axios";
export default {
  components: {
    HeaderTitle,
    numEcharts
  },
  data() {
    return {
      // 标题
      title: "溯源系统一张图",
      // 溯源过程数据
      syprocess: [
        {
          name: "选种和孵化",
          icon: require("../../assets/suyuan/bozhong.png"),
          icon2: require("../../assets/suyuan/bozhong2.png"),
          id: 0,
          drop: require("../../assets/suyuan/dian.png"),
          drop2: require("../../assets/suyuan/dian2.png"),
          background: require("../../assets/suyuan/suyuan.png"),
          background2: require("../../assets/suyuan/suyuan2.png"),
        },
        {
          name: "育雏期",
          icon: require("../../assets/suyuan/youmiao.png"),
          icon2: require("../../assets/suyuan/youmiao2.png"),
          id: 1,
          drop: require("../../assets/suyuan/dian.png"),
          drop2: require("../../assets/suyuan/dian2.png"),
          background: require("../../assets/suyuan/suyuan.png"),
          background2: require("../../assets/suyuan/suyuan2.png"),
        },
        {
          name: "产蛋",
          icon: require("../../assets/suyuan/shengzhang.png"),
          icon2: require("../../assets/suyuan/shengzhang2.png"),
          id: 2,
          drop: require("../../assets/suyuan/dian.png"),
          drop2: require("../../assets/suyuan/dian2.png"),
          background: require("../../assets/suyuan/suyuan.png"),
          background2: require("../../assets/suyuan/suyuan2.png"),
        },
        {
          name: "鸡蛋采集",
          icon: require("../../assets/suyuan/kaihua.png"),
          icon2: require("../../assets/suyuan/kaihua2.png"),
          id: 3,
          drop: require("../../assets/suyuan/dian.png"),
          drop2: require("../../assets/suyuan/dian2.png"),
          background: require("../../assets/suyuan/suyuan.png"),
          background2: require("../../assets/suyuan/suyuan2.png"),
        },
        {
          name: "质量检测",
          icon: require("../../assets/suyuan/jieguo.png"),
          icon2: require("../../assets/suyuan/jieguo2.png"),
          id: 4,
          drop: require("../../assets/suyuan/dian.png"),
          drop2: require("../../assets/suyuan/dian2.png"),
          background: require("../../assets/suyuan/suyuan.png"),
          background2: require("../../assets/suyuan/suyuan2.png"),
        },
        {
          name: "包装和标识",
          icon: require("../../assets/suyuan/chengshu.png"),
          icon2: require("../../assets/suyuan/chengshu2.png"),
          id: 5,
          drop: require("../../assets/suyuan/dian.png"),
          drop2: require("../../assets/suyuan/dian2.png"),
          background: require("../../assets/suyuan/suyuan.png"),
          background2: require("../../assets/suyuan/suyuan2.png"),
        },
        {
          name: "物流和运输",
          icon: require("../../assets/suyuan/shouhuo.png"),
          icon2: require("../../assets/suyuan/shouhuo2.png"),
          id: 6,
          drop: require("../../assets/suyuan/dian.png"),
          drop2: require("../../assets/suyuan/dian2.png"),
          background: require("../../assets/suyuan/suyuan.png"),
          background2: require("../../assets/suyuan/suyuan2.png"),
        },
        {
          name: "销售和分销",
          icon: require("../../assets/suyuan/cunchu.png"),
          icon2: require("../../assets/suyuan/cunchu2.png"),
          id: 7,
          drop: require("../../assets/suyuan/dian.png"),
          drop2: require("../../assets/suyuan/dian2.png"),
          background: require("../../assets/suyuan/suyuan.png"),
          background2: require("../../assets/suyuan/suyuan2.png"),
        },
      ],
      // 默认选中的溯源过程
      syprocessIndex: 0,
      qrcodeValue:
        "http://43.137.43.240:19791/erwm?vcCutsNo=202405204504000001&orgcode=undefined&agribarcode=6",
      syList: [
        {
          packName: "有机鲜鸡蛋",
          tile: "选种和孵化",
          shebei: "王大",
          timestamp: "2023-12-01~2023-12-23",
          title: "选择优质的鸡蛋进行孵化。鸡蛋从受精到孵化成雏鸡大约需要21天。",
          icon: require("../../assets/suyuan/ji-1.png"),
        },
        {
          packName: "有机鲜鸡蛋",
          tile: "育雏期",
          shebei: "王二",
          title: "雏鸡在养殖场中成长，接受适当的饲料和管理，直到能够开始产蛋。",
          timestamp: "2023-12-23~2024-02-09",
          icon: require("../../assets/suyuan/ji-2.png"),
        },
        {
          packName: "有机鲜鸡蛋",
          tile: "产蛋",
          shebei: "王三",
          title: "雌性鸡只开始产蛋，鸡蛋进入生产流程。",
          timestamp: "2024-02-09~2023-04-15",
          icon: require("../../assets/suyuan/ji-3.png"),
        },
        {
          packName: "有机鲜鸡蛋",
          tile: "鸡蛋采集",
          shebei: "王四",
          title: "每天采集新鲜鸡蛋，记录采集日期和时间。",
          timestamp: "每日进行",
          icon: require("../../assets/suyuan/ji-4.png"),
        },
        {
          packName: "有机鲜鸡蛋",
          tile: "质量检测",
          shebei: "王五",
          title: "对鸡蛋进行质量和安全检测。",
          timestamp: " 采集后24小时内",
          icon: require("../../assets/suyuan/ji-5.png"),
        },
        {
          packName: "有机鲜鸡蛋",
          tile: "包装和标识",
          shebei: "王六",
          title: "对鸡蛋进行包装，并在包装上标识生产信息。",
          timestamp: "2024-04-20~2024-04-22",
          icon: require("../../assets/suyuan/ji-6.png"),
        },
        {
          packName: "有机鲜鸡蛋",
          tile: "物流和运输",
          shebei: "王七",
          title:
            " 从生产场地到批发商或零售商的运输时间。运输过程需要保证鸡蛋的质量和新鲜度。",
          timestamp: "2024-04-22~2024-04-27",
          icon: require("../../assets/suyuan/ji-7.png"),
        },
        {
          packName: "有机鲜鸡蛋",
          tile: "销售和分销",
          shebei: "王八",
          title: "鸡蛋到达销售点后，消费者购买到鸡蛋的时间。",
          timestamp: "2024-04-27~2024-05-01",
          icon: require("../../assets/suyuan/ji-8.png"),
        },
      ],
      classOptio: {
        step: 0.5,
      },
      // 产品流通
      listData: [
        {
          name: "美绿思生态农牧科技馆陶有限公司",
          batch: "202405173534000012",
          time: "2023-06-06",
        },
        {
          name: "馆陶县佳凤蛋鸡养殖专业合作社",
          batch: "202405204504000001",
          time: "2023-05-20",
        },
        {
          name: "馆陶县百谷源养殖有限公司",
          batch: "202405223508000003",
          time: "2024-06-03",
        },
        {
          name: "美绿思生态农牧科技馆陶有限公司",
          batch: "202405173534000012",
          time: "2023-06-06",
        },
        {
          name: "美绿思生态农牧科技馆陶有限公司",
          batch: "202405173534000012",
          time: "2023-06-06",
        },
        {
          name: "美绿思生态农牧科技馆陶有限公司",
          batch: "202405173534000012",
          time: "2023-06-06",
        },
      ]
    };
  },
  created() {},
  mounted() {
    this.startTimer();
  },
  updated() {
    this.handleGetQRCode();
  },
  methods: {
    // 定时器
    startTimer() {
      // 设置定时器，每隔1秒执行一次
      this.timer = setInterval(() => {
        // 判断当前选中的溯源过程是否为最后一个
        if (this.syprocessIndex === this.syprocess.length - 1) {
          // 如果是最后一个，则将选中的溯源过程重置为第一个
          this.syprocessIndex = 0;
        } else {
          // 如果不是最后一个，则将选中的溯源过程加1
          this.syprocessIndex++;
        }
      }, 5000);
    },
    changeBackgroundColor(val) {
      this.syprocessIndex = val;
      // 清除定时器
      clearInterval(this.timer);
      // 重新设置定时器
      this.startTimer();
    },
    handleGetQRCode() {
      let code = document.getElementById("qrcodeCanvas");
      console.log(code);
      QRCode.toCanvas(code, this.qrcodeValue);
    },
  },
};
</script>
<style lang="scss" scoped>
// 背景图
#views-page1 {
  box-sizing: border-box;
  background: url(~@/assets/background-img.png) no-repeat center center;
  background-size: 100% 100%;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
}

// 内容
.content {
  color: #fff;
  width: 100%;
  height: 90%;
  box-sizing: border-box;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // 左
  .left {
    width: 28%;
    height: 100%;
    background-image: url("../../assets/suyuan/left.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    // 溯源过程
    .content-left-syjl {
      color: #fff;
      width: 95%;
      height: 90%;
      margin: 30px auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .content-left-syjl-process {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        width: 90%;
        height: 100%;
        .content-left-syjl-process-box {
          position: relative;
          height: 10%;
          width: 100%;
          display: flex;
          align-items: center;
          font-size: 20px;
          font-weight: 600;
          .content-left-syjl-process-box-img1 {
            width: 28px;
            height: 28px;
            position: absolute;
            left: -44px;
          }
          .content-left-syjl-process-box-sj {
            cursor: pointer;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            height: 100%;
            width: 90%;
            margin-left: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
  // 中间
  .center {
    width: 42%;
    height: 100%;
    background-image: url("../../assets/suyuan/zhongjian.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .content-center-detail {
      width: 90%;
      height: 36%;
      margin: 30px auto 2px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      //阶段时长
      .content-center-detail-left {
        width: 38%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .content-center-detail-left-top {
          width: 100%;
          height: 20%;
          background-image: url("../../assets/suyuan/jieduanshichang.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          padding-left: 20px;
        }
        .content-center-detail-left-bottom {
          width: 100%;
          height: 78%;
          overflow: hidden;
          position: relative;
          .content-center-detail-left-bottom-imgg {
            width: 85%;
            height: 71%;
            position: absolute;
            top: 36px;
            left: 22px;
            border-radius: 5px;
            box-shadow: 0 0 10px 0 #00e5e9;
            object-fit: cover;
          }
        }
      }
      //操作信息
      .content-center-detail-right {
        width: 60%;
        height: 100%;
        .content-center-detail-left-bottom-czxx {
          width: 100%;
          height: 80%;
          background-image: url("../../assets/suyuan/jieduanzhaopian.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          overflow: hidden;
          position: relative;
          padding: 40px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          span {
            font-size: 18px;
            font-weight: 600;
          }
        }
        .content-center-detail-right-title {
          width: 100%;
          height: 12%;
          font-weight: 600;
          background-image: url("../../assets/suyuan/chaozuoxx.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          .content-center-detail-right-title2 {
            letter-spacing: 2px;
            background: linear-gradient(to bottom, #ffffff, #21a0f1);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            font-size: 22px;
            font-weight: 600;
            padding-left: 60px;
          }
        }
        .content-center-detail-right-one {
          width: 90%;
          height: 15%;
          margin: 20px auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-weight: 600;
          letter-spacing: 2px;
          div {
            width: 32%;
            height: 100%;
            background-image: url("../../assets/suyuan/detail.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            text-align: center;
            padding-top: 5px;
          }
        }
        .content-center-detail-right-two {
          width: 90%;
          height: 54%;
          margin: 20px auto;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          div {
            height: 25%;
            width: 48%;
            background: linear-gradient(to right, #0a4b88c6, #0a4b8800);
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            font-weight: 600;
            color: #71a9d3;
          }
        }
      }
    }
  }
  // 右
  .right {
    width: 28%;
    height: 100%;
    background-image: url("../../assets/suyuan/left.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    // 溯源码
    .content-right-top {
      width: 90%;
      height: 25%;
      margin: 30px auto 20px;
      display: flex;
      justify-content: space-between;
      .content-right-top-sym {
        height: 70%;
        width: 38%;
      }
    }
    .jsqk-title {
      font-size: 18px;
      font-weight: 600;
      background: linear-gradient(90deg, #022f51, rgba(2, 47, 81, 0));
      width: 100%;
      height: 40px;
      line-height: 40px;
      box-sizing: border-box;
      border-bottom: 3px solid #0064b0;
    }
    .warp {
      width: 100%;
      height: 100%;
      margin: auto 0;
      overflow: hidden;
      .left-echarts-box-list-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 40px;
        background-color: #0a2f593f;
        border: 1px solid #1c4065;
      }
    }
    .right-three-list-title {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-around;
          border: 1px solid #0092d8;
          height: 30px;
          line-height: 30px;
          margin: 10px 0;
        }
  }
}
// 模块名称
.title {
  font-size: 20px;
  letter-spacing: 2px;
  font-weight: bold;
  background: linear-gradient(to bottom, #ffffff, #a3dcff);
  -webkit-background-clip: text !important;
  background-clip: text;
  color: transparent;
  padding: 13px 0 0 40px;
}
</style>
